import { createContext, useContext, useEffect, useState } from "react";
import { api } from "../lib/api";
import { Buildings } from "@phosphor-icons/react";

const Ctx = createContext(null);

export function AgentClientProvider({ children }) {
  const [clients, setClients] = useState([]);
  const [loaded, setLoaded] = useState(false);
  const [sel, setSel] = useState(localStorage.getItem("agent_sel_client") || "");
  useEffect(() => {
    api.get("/agent/clients").then((r) => {
      setClients(r.data);
      if (!r.data.some((c) => c.email === sel)) setSel(r.data[0]?.email || "");
    }).catch(() => {}).finally(() => setLoaded(true));
  }, []);
  useEffect(() => { if (sel) localStorage.setItem("agent_sel_client", sel); }, [sel]);
  const selClient = clients.find((c) => c.email === sel);
  return <Ctx.Provider value={{ clients, sel, setSel, selClient, loaded }}>{children}</Ctx.Provider>;
}

export const useAgentClient = () => useContext(Ctx);

export function ClientPicker() {
  const { clients, sel, setSel } = useAgentClient();
  return (
    <label className="flex items-center gap-2 text-sm">
      <Buildings size={16} className="text-[#002FA7]" />
      <span className="label hidden sm:inline">Client</span>
      <select data-testid="agent-client-picker" value={sel} onChange={(e) => setSel(e.target.value)}
        className="border border-black/20 rounded-sm px-2 py-1.5 text-sm max-w-[130px] sm:max-w-[220px] focus:outline-none focus:ring-2 focus:ring-[#002FA7]">
        {clients.length === 0 && <option value="">No clients assigned</option>}
        {clients.map((c) => <option key={c.email} value={c.email}>{c.company || c.email}</option>)}
      </select>
    </label>
  );
}

export function NeedClient({ children }) {
  const { selClient, loaded } = useAgentClient();
  if (!loaded) return <p className="label">Loading…</p>;
  if (!selClient) return <p data-testid="need-client" className="card p-8 text-sm text-[#888] text-center">No client assigned to you yet. Once admin assigns a client, their work will appear here.</p>;
  return children;
}
